import CircularLoader from "components/CircularLoader/CircularLoader";
import { useRouter } from "components/RouteController/functions/useRouter";
import { Suspense } from "react";
import { RouterProvider } from "react-router";

const RouteController = () => {
  const router = useRouter();

  return (
    <Suspense fallback={<CircularLoader />}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default RouteController;
